import React from 'react'
import { required, SelectInputProps, SelectInput, useGetIdentity } from 'react-admin'
import { COMMON_FIELDS } from '../../providers/localization/constant'

const CHOICES = [
  { id: 'a', name: `${COMMON_FIELDS}.published_to.choices.all_branches` },
  { id: 's', name: `${COMMON_FIELDS}.published_to.choices.specific_branch` },
]

export const PublishCondSelectInput: React.FC<SelectInputProps> = ({
  source = 'publish_condition',
  ...props
}) => {
  const { identity, isLoading } = useGetIdentity()
  if (isLoading) return null
  const { access_level: accessLevel } = identity
  const choices = accessLevel === 'a' ? CHOICES : [CHOICES[1]]

  return (
    <SelectInput
      margin='none'
      fullWidth
      label={`${COMMON_FIELDS}.published_to.label`}
      source={source}
      choices={choices}
      validate={[required()]}
      defaultValue=''
      {...props}
    />
  )
}
